<template>
  <!--
      	作者：luoyiming
      	时间：2019-12-25
      	描述：插件中心-文章
      -->
    <div class="user">
        <div class="common-seach-wrap">
            <el-tabs v-model="activeName">
                <el-tab-pane label="文章管理" name="article">
                    <Article v-if="activeName=='article'"></Article>
                </el-tab-pane>
                <el-tab-pane label="分类管理" name="category">
                    <Category v-if="activeName=='category'"></Category>
                </el-tab-pane>
                <el-tab-pane label="公众号文章" name="mp">
                    <Mp v-if="activeName=='mp'"></Mp>
                </el-tab-pane>
                <el-tab-pane label="基础设置" name="setting">
                    <Setting v-if="activeName=='setting'"></Setting>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import ArticleApi from '@/api/article.js';
    import Article from './article/Index.vue';
    import Category from './category/Index.vue';
    import Mp from './mp/mp.vue';
    import Setting from './setting/setting.vue';
    export default {
        components: {
            Article,
            Category,
            Mp,
            Setting
        },
        data() {
            return {
                activeName: 'article',
                /*是否加载完成*/
                loading: true,
            }
        },
        created() {


        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/views/plus/article/index.vue